import type { CreationAsset, CreationVersion } from '@djgg/creations';

/** Working-head attachment is not publication. Role names alone cannot prove
 * that the currently attached variant is contained in the active version. */
export function assetPublicationState(
  asset: Pick<CreationAsset, 'name' | 'variantId' | 'kind'>,
  activeVersion: number,
  version: Pick<CreationVersion, 'n' | 'assetsSnapshot'> | null,
): 'no-live-version' | 'unknown' | 'contained-in-active' | 'replacement-pending' | 'not-in-active' {
  if (!activeVersion) return 'no-live-version';
  if (!version || version.n !== activeVersion || !version.assetsSnapshot) return 'unknown';
  const previous = version.assetsSnapshot.find(item => item.name === asset.name && item.kind === asset.kind);
  if (!previous) return 'not-in-active';
  return previous.variantId === asset.variantId ? 'contained-in-active' : 'replacement-pending';
}

export function assetPublicationLabel(state: ReturnType<typeof assetPublicationState>, activeVersion: number): string {
  switch (state) {
    case 'no-live-version': return 'Working copy · no live version yet';
    case 'unknown': return 'Working copy · live variant not verified';
    case 'contained-in-active': return `Included in live v${activeVersion}`;
    case 'replacement-pending': return `Replacement ready · live v${activeVersion} still has the previous variant`;
    case 'not-in-active': return `Working copy only · not included in live v${activeVersion}`;
  }
}
